import { twMerge } from 'tailwind-merge';

export const Background = ({ className }: { className?: string }) => (
  <div
    className={twMerge(
      "bg-[url('/images/auth-background.jpg')] bg-cover bg-center opacity-20",
      className
    )}
  />
);
